// @flow

import * as React from 'react';
import { withRouter } from 'react-router-dom';

type Props = {
  children?: React.Node,
  icon?: ?React.Node,
}

type State = {
  ref: ?HTMLDivElement,
  className?: string,
  contentRef: ?HTMLDivElement,
  isVisible: boolean,
}

class Tooltip extends React.Component<Props, State> {
  static defaultProps = {
    children: null,
    icon: null,
  };

  state = {
    ref: null,
    contentRef: null,
    isVisible: false,
  };

  renderInfoOffset = () => {
    // default values
    let maxWidth = 500;
    let className = 'tooltip-right';

    if (this.state.ref && this.state.contentRef) {
      const middlePage = window.innerWidth / 2;
      const elementPosition = this.state.ref.getBoundingClientRect().x;

      // Display elements on the side with most space and with maximum possible width
      maxWidth =
        window.innerWidth - elementPosition // Right side
        - 20; // Substract space of position
      if (elementPosition > middlePage) {
        className = 'tooltip-left';
        maxWidth =
          elementPosition // Left side
          - 5; // Substract space of position
      }
    }

    maxWidth -= 20; // Substract space for padding

    return {
      className,
      maxWidth,
    };
  };

  getTooltipInfo = () => {
    const infoOffset = this.renderInfoOffset();
    return (
      <div
        ref={(ref) => {
          if (!this.state.contentRef) {
            this.setState({ contentRef: ref });
          }
        }}
        className={`tooltip-content ${infoOffset.className}`}
        style={{ maxWidth: `${infoOffset.maxWidth}px` }}
      >
        {this.props.children}
      </div>
    );
  }

  render() {
    return (
      <div
        ref={(ref) => {
          if (!this.state.ref) {
            this.setState({ ref });
          }
        }}
        className="little-info-button tooltip-container"
        onMouseEnter={() => this.setState({ isVisible: true })}
        onMouseLeave={() => this.setState({ isVisible: false })}
      >
        <div>
          {this.props.icon ?
            this.props.icon
            : (<i className="fa fa-info-circle" />)
          }
        </div>
        {this.state.isVisible && this.getTooltipInfo()}
      </div>
    );
  }
}

export default withRouter(Tooltip);
